/**
 * The height a textarea takes while its resize handle is dragged: where it
 * started, moved by how far the pointer has travelled vertically, and never
 * shorter than `minHeight` -- the height its `rows` gave it, so a drag can
 * shrink it back but not below where it began.
 */
export function resizedTextareaHeight({
  startHeight,
  startY,
  currentY,
  minHeight,
}: {
  startHeight: number
  startY: number
  currentY: number
  minHeight: number
}): number {
  return Math.max(minHeight, startHeight + (currentY - startY))
}
